<template>
    <div :key="iteration">
        <loading v-show="isLoading"></loading>

        <section>
            <form @submit.prevent="start()">
                <div class="form-group">
                    <label for="adviser">
                        Adviser
                    </label>

                    <input
                        id="adviser"
                        type="text"
                        inputmode="text"
                        class="form-control"
                        name="adviser"
                        required
                        autocomplete="adviser"
                        v-model="adviserName"
                    >
                </div>

                <div v-if="investor" class="form-group">
                    <input
                        id="investor"
                        type="hidden"
                        name="investor"
                        v-model="investor"
                    >

                    <label for="investor">
                        Investor
                    </label>

                    <input
                        id="investorName"
                        type="text"
                        inputmode="text"
                        class="form-control"
                        name="investorName"
                        required
                        disabled
                        v-model="investorDisplay"
                    >

                    <button type="button" class="button" @click.stop="deselectInvestor($event)">
                        Clear Investor
                    </button>
                </div>

                <div v-else class="form-group">
                    <label for="investor">
                        Investor
                    </label>

                    <p>
                        <a href="/my-investors" class="button">
                            Select Investor
                        </a>
                    </p>
                </div>

                <div class="form-group">
                    <label for="name">
                        Name on report
                    </label>

                    <input
                        id="name"
                        type="text"
                        inputmode="text"
                        class="form-control"
                        name="name"
                        required
                        maxlength="100"
                        autocomplete="name"
                        v-model="clientName"
                    >
                </div>

                <div class="form-group form-group-selectr">
                    <label for="riskRated">
                        Risk Level
                    </label>

                    <select
                        id="riskRated"
                        class="form-control"
                        name="riskRated"
                        required
                        v-model="value">
                        <option v-for="option in options" :value="option.id" v-html="option.value"></option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="amount">
                        Amount (&pound;)
                    </label>

                    <input
                        id="amount"
                        type="text"
                        inputmode="numeric"
                        class="form-control"
                        name="amount"
                        required
                        autocomplete="amount"
                        v-model="amount"
                    >
                </div>

                <div v-if="partial" class="form-group" v-html="partial"></div>

                <div class="form-group">
                    <button type="submit" class="button button-primary">
                        Generate Report
                    </button>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
    import Widget from './Widget.vue';
    import MargettsApi from '../modules/margetts-api';
    import Loading from "./Loading.vue";

    export default {
        extends: Widget,
        components: {Loading},

        data() {
            return {
                iteration: 0,
                isLoading: true,
                adviserName: null,
                investor: null,
                investorCode: null,
                investorName: null,
                investorDisplay: null,
                clientName: null,
                options: [],
                value: this.default,
                amount: '100000',
                partial: '',
                classes: 'risk-rated-report-widget',
            }
        },

        created() {
            this.render();
            this.registerParameterListener('range');
        },

        methods: {
            render() {
                this.block();

                this.iteration += 1;
                this.adviserName = this.parameters.adviserName;
                this.investor = this.parameters.investor;
                this.investorCode = this.parameters.investorCode;
                this.investorName = this.parameters.investorName;
                this.investorDisplay = this.investorName + ' (' + this.investorCode + ')';
                this.clientName = this.parameters.investorName;
                this.partial = this.parameters.partial;

                MargettsApi.get('adviser/risk-rated-list', this.createQueryStringFromParameters({
                    user: 'userId'
                }, false), response => {
                    if ( ! response || ! response.result) {
                        return MargettsApi.throwNoResponseError();
                    }

                    if (response.result !== 'success') {
                        return this.throwApiError(response.messages);
                    }

                    const data = response.data;

                    this.options = data.items;

                    this.setDefault();
                    this.setValue();

                    this.unblock();

                }).catch(error => {
                    return MargettsApi.throwError(error);
                });
            },

            setDefault() {
                const urlSearchParameters = new URLSearchParams(window.location.search);

                if (urlSearchParameters.has('riskRated')) {
                    this.default = urlSearchParameters.get('riskRated');
                }
            },

            setValue() {
                if (this.iteration === 1 && this.default) {
                    this.value = this.default;
                } else {
                    this.options.forEach(option => {
                        if (option.selected) {
                            this.value = option.id;
                        }
                    });
                }
            },

            start() {
                this.block();

                const parameters = {
                    'investor': this.investor,
                    'name': this.clientName,
                    'riskRated': this.value,
                    'amount': this.amount,
                    'user': 'userId'
                };

                if (! this.validateParameters(parameters)) {
                    return this.throwValidationError();
                }

                MargettsApi.post('adviser/risk-rated-report', this.createQueryStringFromParameters(parameters, false), response => {
                    if ( ! response || ! response.result) {
                        return MargettsApi.throwNoResponseError();
                    }

                    if (response.result !== 'success') {
                        return this.throwApiError(response.messages);
                    }

                    const data = response.data;

                    if (data.file) {
                        this.awaitFileInBackground(data.file.name, data.file.path);
                    }

                    if (response.messages) {
                        flash(response.messages.join('<br>'), 'success');
                    }

                    this.unblock();
                }).catch(error => {
                    MargettsApi.throwError(error);
                });
            },

            validate(parameters) {
                if (isNaN(parameters.amount)) {
                    this.addValidationMessage('Please provide a whole number in the amount field.');
                } else if (parameters.amount <= 0) {
                    this.addValidationMessage('Please provide a number greater than zero in the amount field.');
                }
            }
        }
    }
</script>
